import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PatientForm from "./Component/PatientForm";
import SuccessPage from "./Component/SuccessPage";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<PatientForm />} />
        <Route path="/success" element={<SuccessPage />} />
      </Routes>
    </Router>
  );
}

export default App;
